import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from 'react-router-dom';

import {
  Button,
  TextField,
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  // Select,
} from "@mui/material";
import {
  DatePicker,
  TimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { v4 as uuid } from 'uuid';
import Select from 'react-select';
import { ROLE_OPTIONS } from '../../../constants';

export const InterviewForm = ({ tutorId , tutStatus ,tutStatusUpdate , setTutStatusUpdate }) => {
  const { handleSubmit, control } = useForm();
  const history = useNavigate();
  const [interviewData , setInterviewData] = useState()
   const [selectedOptions, setSelectedOptions] = useState([]);
  console.log("Interview Scheduled:", tutStatus);
  
  const onSubmit = async(data) => {
    console.log("Interview Scheduled:", data);
    let selectedOptionAr = []
    selectedOptions.map(el => selectedOptionAr.push(el.value))

    const saveInterviewDateTime = await axios.put(`https://testapis4.el.r.appspot.com/api/tutorWeb/savePreferedInterviewDateTime/${tutorId}`,{
      interviewId : uuid(),
      // preferredStartTime : new Date(data?.startTime),
      // prefererdEndTime : new Date(data?.endTime),
      tutorNotes:data?.notes,
      tutStatus:"intrvreg",
      role:selectedOptionAr
    })
    if(saveInterviewDateTime?.data?.success){
      setTutStatusUpdate(!tutStatusUpdate)
      alert('Form Submitted Successfully')
    }
    // Add submission logic here (API calls, etc.)
  };

  const saveSkill = async() => {
    // console.log("Interview Scheduled:", data);
    // const saveInterviewDateTime = await axios.put(`https://testapis4.el.r.appspot.com/api/tutorWeb/savePreferedInterviewDateTime/${tutorId}`,{
    //   interviewId : uuid(),
    //   preferredStartTime : new Date(data?.startTime),
    //   prefererdEndTime : new Date(data?.endTime),
    //   tutorNotes:data?.notes,
    //   tutStatus:"intrvreg",
    //   role:data?.role
    // })
    // if(saveInterviewDateTime?.data?.success){
    //   setTutStatusUpdate(!tutStatusUpdate)
    //   alert('Form Submitted Successfully')
    // }
    let selectedOptionAr = []
    selectedOptions.map(el => selectedOptionAr.push(el.value))

    const intData = {
      marks:"60",
      role:selectedOptionAr
    }
    setInitialRtingTagsForMusic(intData)
    dashboardEntry()
  };

  const handleSelectChange = (selected) => {
    console.log({selected})
    setSelectedOptions(selected);
  };
  const fetchInterviewData = async() =>{
      const getInterviewData = await axios.get(`https://testapis4.el.r.appspot.com/api/tutorWeb/getInterviewData/${tutorId}`)
      if(getInterviewData?.data && getInterviewData?.data?.success ){
        const interviewObj = getInterviewData?.data?.interviewedData[getInterviewData?.data?.interviewedData?.length - 1]
        setInterviewData(interviewObj)
        console.log({interviewObj})
        if(getInterviewData?.data?.tutUpdated)setTutStatusUpdate(!tutStatusUpdate)
      }
  }

  useEffect(()=>{
    fetchInterviewData()
  },[])


  const setInitialRtingTagsForMusic = async(data) =>{
    let marksVal = +data?.marks
    let initialRating =  marksVal < 70 ? 5 : marksVal > 70 && marksVal <= 75
    ? 6
    : marksVal > 75 && marksVal <= 80
    ? 7
    : marksVal > 80 && marksVal <= 85
    ? 8
    : marksVal > 85 && marksVal <= 90
    ? 9
    : marksVal > 90
    ? 10 : null;

    const updateTutorInfo = await axios.post(
      `https://central-device-apis.el.r.appspot.com/api/tutorweb/updateTagsAndInitialRatingInMain/${
        JSON.parse(window.localStorage.getItem("tutor")).saveTutor.tutor_id
      }`,
      {
        tags:data?.role,
        rating :initialRating + ""
      }
    );
  }

  const dashboardEntry = async () => {
    let tutor1 = JSON.parse(localStorage.getItem("tutor"));
    let tutor_ls = JSON.parse(localStorage.getItem("tutor")).saveTutor;

    let temp_tutorSaveObj = {
      ...tutor_ls,
      tutStatus: "db",
    };
    console.log({ tutor_ls });
    let temp_tutorObj = {
      ...tutor1,
      saveTutor: temp_tutorSaveObj,
    };
    let tutor_stringified = JSON.stringify(temp_tutorObj);
    localStorage.setItem("tutor", tutor_stringified);

    const res = await axios({
      method: "post",
      // url: "https://central-device-apis.el.r.appspot.com/api/tutorWeb/tutor_save",
      url: `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/setTutStatus/${
        // url: `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/setTutStatus/${
        JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id
        }`,
      data: {
        tutStatus: "db",
      },
    });
    if (res.data) {
      history("/tutor_dashboard",{replace:true});
      window.location.reload();
    } else {
      console.log("not saved tutStatus in db");
    }
  };

  const handleNext = () =>{
    setInitialRtingTagsForMusic(interviewData)
    dashboardEntry()
    // history.push('/tutor_exam/terms_condition')
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f0f4f7",
        }}
      >
        <Card sx={{ width: 500, boxShadow: 3 }}>
          {tutStatus == "intrvfm" ? (
             <CardContent>
             <Typography variant="h5" align="center" gutterBottom>
             Share Your Musical Mastery
               {/* Provide Your Preferred Interview Time */}
             </Typography>
             <Box
               component="form"
               onSubmit={handleSubmit(onSubmit)}
               sx={{ mt: 3 }}
             >
               <Grid container spacing={2}>
                 {/* Interviewer Name */}
                 {/* <Grid item xs={12}>
                 <Controller
                   name="interviewer"
                   control={control}
                   defaultValue=""
                   render={({ field }) => (
                     <TextField
                       fullWidth
                       label="Interviewer Name"
                       variant="outlined"
                       {...field}
                     />
                   )}
                 />
               </Grid> */}

                 {/* Interview Mode */}
                 {/* <Grid item xs={12}>
                 <Controller
                   name="mode"
                   control={control}
                   defaultValue=""
                   render={({ field }) => (
                     <FormControl fullWidth variant="outlined">
                       <InputLabel id="mode-label">Interview Mode</InputLabel>
                       <Select
                         labelId="mode-label"
                         label="Interview Mode"
                         {...field}
                       >
                         <MenuItem value="virtual">Virtual</MenuItem>
                         <MenuItem value="in-person">In-Person</MenuItem>
                       </Select>
                     </FormControl>
                   )}
                 />
               </Grid> */}

                 {/* Date Picker */}
                 
                 <Grid item xs={12}>
                 {/* <Controller
                     name="role"
                     control={control}
                     defaultValue=""
                     render={({ field }) => (
                       <FormControl fullWidth variant="outlined">
                         <InputLabel id="roles-label">Select A Skill</InputLabel>
                         <Select
                           labelId="roles-label"
                           label="Select Role"
                           {...field} // Spread field props here for react-hook-form
                         >
                         {ROLE_OPTIONS.map(option => <MenuItem value={option}>{option}</MenuItem>)}
                         </Select>
                       </FormControl>
                     )}
                   /> */}
                   <div>
                   <Select
                     isMulti
                     name="skills"
                     options={ROLE_OPTIONS}
                     value={selectedOptions}
                     onChange={handleSelectChange}
                     className="basic-multi-select"
                     classNamePrefix="select"
                   />
                   <div>
                     {/* <h4>Selected Fruits:</h4> */}
                     <ul>
                       {selectedOptions.map((option) => (
                         <li key={option.value}>{option.label}</li>
                       ))}
                     </ul>
                   </div>
                 </div>
               </Grid> 

                 {/* Start Time Picker */}
                 {/* <Grid item xs={6}>
                   <Controller
                     name="startTime"
                     control={control}
                     defaultValue={null}
                     render={({ field }) => (
                       <TimePicker
                         label="Start Time"
                         renderInput={(params) => (
                           <TextField fullWidth {...params} />
                         )}
                         {...field}
                       />
                     )}
                   />
                 </Grid> */}

                 {/* End Time Picker */}
                 {/* <Grid item xs={6}>
                   <Controller
                     name="endTime"
                     control={control}
                     defaultValue={null}
                     render={({ field }) => (
                       <TimePicker
                         label="End Time"
                         renderInput={(params) => (
                           <TextField fullWidth {...params} />
                         )}
                         {...field}
                       />
                     )}
                   />
                 </Grid> */}

                 {/* Notes */}
                 {/* <Grid item xs={12}>
                   <Controller
                     name="notes"
                     control={control}
                     defaultValue=""
                     render={({ field }) => (
                       <TextField
                         fullWidth
                         multiline
                         rows={3}
                         label="Additional Notes (Optional)"
                         variant="outlined"
                         {...field}
                       />
                     )}
                   />
                 </Grid> */}

                 {/* Submit Button */}
                 <Grid item xs={12}>
                   <Button
                     variant="contained"
                     color="primary"
                     fullWidth
                     type="submit"
                     sx={{ mt: 2, py: 1.5 }}
                     // onClick={saveSkill}
                   >
                     Submit
                   </Button>
                 </Grid>
               </Grid>
             </Box>
           </CardContent>
          ) : tutStatus == "intrvreg" ? (
            <CardContent>
              <Typography variant="h5" align="center" gutterBottom>
                Interview Scheduling in Progress
              </Typography>
              <Box
                // component="form"
                onSubmit={handleSubmit(onSubmit)}
                sx={{ mt: 3 }}
              >
                Our team is arranging for your interview.We'll get back to you
                right away.
              </Box>
            </CardContent>
          ) : tutStatus == "intrvres" ? (
            <CardContent>
              <Typography variant="h5" align="center" gutterBottom>
                Interview Result
              </Typography>
             {interviewData?.status == 'pass' ? 
             <>
             <Box
                // component="form"
                onSubmit={handleSubmit(onSubmit)}
                sx={{ mt: 3 }}
              >
                <p>You have successfully passed the interview</p>
              </Box>
              <Typography style={{textAlign:"center" , marginTop:"10px"}}>
               <Button variant="contained" onClick = {handleNext}>Next</Button>
               </Typography>
              </>
              :
              <>
              <Box
                // component="form"
                onSubmit={handleSubmit(onSubmit)}
                sx={{ mt: 3 }}
              >
                You have failed the interview.Try again after 10 days!
              </Box>
              <Typography style={{textAlign:"center" , marginTop:"10px"}}>
               <Button variant="disabled">Next</Button>
               </Typography>
              </>
              }
            
            </CardContent>
          ) : (
            <CardContent>
              <Typography variant="h5" align="center" gutterBottom>
                Page Not Available
              </Typography>
            </CardContent>
          )}
        </Card>
      </Box>
    </LocalizationProvider>
  );
};

export default InterviewForm;